// extracted by mini-css-extract-plugin
export default {"grid":"style_grid__G5Aib","grid_img":"style_grid_img__96Y9u","grid_heading":"style_grid_heading__UGKP-","grid_press":"style_grid_press__xfx4g","grid_arrow":"style_grid_arrow__7vApB"};